var MiniLogin = (function () {

    return {
        addClickEvent: addClickEvent,
        setMiniAutoCheck: setMiniAutoCheck,
        clickMiniAutoCheck: clickMiniAutoCheck,
        createMiniError: createMiniError,
        clearMiniError: clearMiniError,
    }

    function setMiniAutoCheck(isAutoCheck) {
        const $checkIcon = $("#autoCheck");
        if(HecConfig.isHec()) {
            $checkIcon.hide();
            return;
        }
        $checkIcon.attr('class', (isAutoCheck === 'Y' ? 'mini-mode-check-icon-2' : 'mini-mode-check-icon-1'));
        LocalUtil.setLocal("ONLY_AUTO_LOGIN_YN", isAutoCheck === 'Y' ? 'Y' : 'N');
    }

    function clickMiniAutoCheck(e) {
        var $autoCheck = $('#autoCheck');
        $autoCheck.toggleClass('mini-mode-check-icon-2').toggleClass('mini-mode-check-icon-1');
        return $autoCheck.hasClass('mini-mode-check-icon-2');
    }

    function createMiniError(targetObj) {
        targetObj.addClass('mini-mode-alert-color-1').focus();
    }

    function clearMiniError(targetObj) {
        targetObj.removeClass("mini-mode-alert-color-1");
        targetObj.closest('#loginForm').find('#errorText').removeClass('active');
    }

    function addClickEvent() {
        $("#miniSocialLoginButton").off("click").on("click", clickSocialLoginButton);
        $("#miniBackButton").off("click").on("click", clickBackButton);
        $("#loginForm").off("click").on("click", CommonLogin.clickBottomSection);
        $(".window_top").off("click").on("click", clickEventMiniTop);
    }

    function clickSocialLoginButton() {
        $("#miniNormalLogin").css('display', 'none');
        $("#miniSocialLogin, #miniBackButton").fadeIn(200);
    }

    function clickBackButton() {
        $("#miniNormalLogin").fadeIn(200);
        $("#miniSocialLogin, #miniBackButton").css('display', 'none');
    }

    function clickEventMiniTop() {
        var $eTarget = $(event.target);
        var $winElectronBtn = $eTarget.findUp('.win_elec_btn')
        if ($winElectronBtn.length === 0) return false;

        if ($winElectronBtn.hasClass('win_elec_btn-fold')) return ElectronApi.Window.setState({target: "fold"});
        else if ($winElectronBtn.hasClass('win_elec_btn-set')) return ElectronApi.Window.setState({target: "maximize"});
        else if ($winElectronBtn.hasClass('win_elec_btn-close')) return ElectronApi.Window.setState({target: "close"});
        // if($winElectronBtn.hasClass('win_elec_btn-fold')) return Electron.setWindowState("fold")
        // else if($winElectronBtn.hasClass('win_elec_btn-set')) return Electron.setWindowState("maximize")
        // else if($winElectronBtn.hasClass('win_elec_btn-close')) return Electron.setWindowState("close")
    }
})()
